module.exports = __webpack_public_path__ + "img/nav04_h.88675525.png";